import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import Icon from 'components/AppIcon';
import LoginForm from './components/LoginForm';
import LoginHeader from './components/LoginHeader';
import OAuthButtons from './components/OAuthButtons';
import { useAuth } from 'shared/context/AuthContext';
import {Flex, Button, Input, Divider } from 'antd';

const LoginScreen = () => {
  const navigate = useNavigate();
  const { login, isLoading: authLoading } = useAuth();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');

  const handleLogin = async (formData) => {
    setIsLoading(true);
    setError('');

    try {
      await login(formData.email, formData.password);
      
      // После успешного логина редирект на главную
      // AuthContext загрузит данные пользователя автоматически
      navigate('/dashboard');
    } catch (err) {
      // Обработка ошибок API
      if (err.status === 401) {
        setError('Неверный email или пароль. Проверьте правильность введенных данных.');
      } else if (err.message) {
        setError(err.message);
      } else {
        setError('Произошла ошибка при входе в систему. Попробуйте позже.');
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Flex align="center" justify="center" className="min-h-screen from-primary-50 to-accent-50 px-4 py-8 bg-[rgba(252,212,212,0)] border-[rgba(254,230,240,1)]">
      <div className="w-full max-w-md">
        {/* Header */}
        <LoginHeader />

        {/* Login Form Card */}
        <div className="bg-surface rounded-xl shadow-lg border border-secondary-200 p-8">
          <div className="mb-6">
            <h1 className="text-2xl font-semibold text-text-primary mb-2">
              Вход в систему
            </h1>
            <p className="text-text-secondary">
              Введите ваши учетные данные для доступа к Artseabox
            </p>
          </div>

          {/* Error Message */}
          {error &&
          <div className="mb-6 p-4 bg-error-50 border border-error-200 rounded-md">
              <div className="flex items-center gap-3">
                <Icon name="AlertCircle" size={20} className="text-error flex-shrink-0" />
                <p className="text-sm text-error">{error}</p>
              </div>
            </div>
          }

          {/* Login Form */}
          <LoginForm onSubmit={handleLogin} isLoading={isLoading || authLoading} />

          {/* OAuth Buttons */}
          {/* <Divider className="mt-4 my-4">или войти через</Divider>
          <OAuthButtons disabled={isLoading || authLoading} className="mt-2" /> */}

          {/* Additional Links */}
          <Divider className="mt-4 my-4" />
          <Flex vertical className="gap-4 mt-2">
            <Button
              size="large"
              onClick={() => navigate('/register')}
              disabled={isLoading || authLoading}
              className="
                flex items-center justify-center px-4 py-3 rounded-md font-medium text-base
              "
              icon={<Icon name="UserPlus" size={18} className="mr-2" />}
            >
              Зарегистрироваться
            </Button>

            <div className="text-center">
              <Link
                to="/password-reset"
                className="text-sm text-text-secondary hover:text-primary transition-colors duration-150"
              >
                Забыли пароль?
              </Link>
            </div>
          </Flex>
        </div>

        {/* Footer */}
        <div className="mt-8 text-center">
          <Flex align="center" justify="center" className="gap-6 text-sm text-text-secondary mb-4">
            <Link to="/privacy" className="hover:text-primary transition-colors duration-150">
              Политика конфиденциальности
            </Link>
            <Link to="/terms" className="hover:text-primary transition-colors duration-150">
              Условия использования
            </Link>
            <Link to="/support" className="hover:text-primary transition-colors duration-150">
              Поддержка
            </Link>
          </Flex>
          <p className="text-xs text-secondary-400">
            © {new Date().getFullYear()} Artseabox. Все права защищены.
          </p>
        </div>
      </div>
    </Flex>
  );
};

export default LoginScreen;